export function calculateLineStyles(fieldRefs, outputRefs, connector, index, containerRef, connectorsLength, selectedAPIId, color = "#000000") {
    const fromElement = fieldRefs.current.get(connector);
    const toElement = outputRefs.current.get(selectedAPIId);
    const containerElement = containerRef.current;
  
    if (!fromElement || !toElement || !containerElement) {
      return { styles: null };
    }
  
    const fromRect = fromElement.getBoundingClientRect();
    const toRect = toElement.getBoundingClientRect();
    const containerRect = containerElement.getBoundingClientRect();
  
    const fullWidth = toRect.left - fromRect.right;
    const offsetX = fullWidth / (connectorsLength * 2) * (index + 1);
    const offsetY1 = fromRect.height / 4 + (fromRect.height / 4) / connectorsLength * (index + 1);
    const offsetY2 = toRect.height / 4;
  
    const startX = fromRect.right - containerRect.left;
    const startY = fromRect.top - containerRect.top + offsetY1;
    const width1 = offsetX;
    const width2 = fullWidth - width1;
    const endY = toRect.top - containerRect.top + offsetY2;
  
    const styles = {
      line1: {
        left: `${startX}px`,
        top: `${startY}px`,
        width: `${width1}px`,
        height: '2px',
        backgroundColor: color,
        position: 'absolute',
      },
      line2: {
        left: `${startX + width1}px`,
        top: `${endY}px`,
        width: `${width2}px`,
        height: '2px',
        backgroundColor: color,
        position: 'absolute',
      },
      line3: {
        left: `${startX + width1}px`,
        top: `${startY < endY ? startY : endY}px`,
        width: `2px`,
        height: `${Math.abs(endY - startY)}px`,
        backgroundColor: color,
        position: 'absolute',
      },
    };
  
    return { styles };
  }
  